<template>  
  <div class="create-reduced-kidney-function-drug">
    <div class="row">
      <div class="col-sm-12">
        <mu-text-field v-model="drugName" label="Läkemedelsnamn" labelFloat/>
      </div>
      <div class="col-sm-12">
        <mu-raised-button class="demo-raised-button" label="Lägg till" icon="add" primary @click="createReducedKidneyFunctionDrug"/>
        <mu-raised-button class="demo-raised-button" label="Avbryt" icon="cancel" @click="closeDialog"/>
      </div>
    </div>
  </div>
</template>

<script>
import { createReducedKidneyFunctionDrug } from '../store/actions'

export default {
  name: 'CreateReducedKidneyFunctionDrug',
  data () {
    return {
      drugName: ''
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    createReducedKidneyFunctionDrug () {
      createReducedKidneyFunctionDrug(this.$store, this.drugName)
    },
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>
